import { render, staticRenderFns } from "./exercises-test-library.vue?vue&type=template&id=4126f114"
import script from "./exercises-test-library.vue?vue&type=script&lang=js"
export * from "./exercises-test-library.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports